module.exports = __webpack_public_path__ + "img/icon-close.6f90199d.svg";